export function portalFeatureSelection (state = {
  newSettingsUi: true
}, action: any) {
  switch (action.type){
    case 'ENABLE_NEW_SETTINGS_UI':
      state.newSettingsUi = true
      return {...state}
      break
    case 'DISABLE_NEW_SETTINGS_UI':
      state.newSettingsUi = false
      return {...state}
      break
    default:
      return state
  }
}
